define('Components/PageHeaderWidget/js/views/PageHeaderWidgetInstanceView',['jquery',
        'WidgetInstanceView',
        'app',
        'AddressAutocompleteView',
        'template!Components/PageHeaderWidget/templates/home',
        'template!Components/PageHeaderWidget/templates/home-v2',
        'TagCommander',
        'InternalLinkView',
        'iphone-inline-video',
    ],
    function ($, WidgetInstanceView, app,
              AddressAutocompleteView,
              HomeTemplate,
              HomeV2Template,
              TagCommander,
              InternalLinkView
    ) {
        return WidgetInstanceView.extend({
            name: 'PageHeaderWidgetInstanceView',
            events: {
                'click input': 'onInputClick',
                'click a.cta': 'trackCTA'
            },
            setup: function () {
            },
            getTemplate: function () {
                var templateName = this.model.getTemplate();
                switch (templateName) {
                    case 'home':
                        return HomeTemplate;
                    case 'home-v2':
                        return HomeV2Template;
                }
            },
            onDeliveryUpdate: function () {
                app.go('listing');
            },
            onInputClick: function (e) {
                if (app.isMobile()) {
                    e.preventDefault();
                    e.stopPropagation();
                    var view = this,
                        autocompleteView = view.autocompleteView,
                        currentTarget = $(e.currentTarget);
                    //
                    currentTarget.blur();
                    var isFilter = currentTarget.is('[name="filter"]'),
                        isFilterStore = currentTarget.is('.filter-store'),
                        type = isFilter ? isFilterStore ? 'store':'address':autocompleteView.type;
                    var modalView = view.attachView(
                        new AddressAutocompleteView({
                            theme: 'modal',
                            autoSubmit: true,
                            type: type,
                            displayFilters:autocompleteView.displayFilters
                        })
                    );
                    modalView.once('close', function () {
                        modalView.off();
                    });
                    modalView.on('updateType',function(newType){
                        console.log('updateType',newType);
                        autocompleteView.updateType(newType,true);
                    });
                    console.log('updateType',type);
                    //autocompleteView.updateType(type,true);

                    view.listenToOnce(modalView,'complete',view.onDeliveryUpdate);
                    app.displayModal(modalView);
                    modalView.$el.parent().addClass('ignore-animation');
                    
                    modalView.autoFocus(); 
                }
            },
            afterRender: function () {
                var view = this, model = view.model;
                //
                //
                //
                //
                var store_preset = model.p('store_preset'),
                    autocompleteOptions = {
                    el: this.$('.address-autocomplete-container').get(0),
                    theme: 'home',
                    autoSubmit: true
                };
                console.log('store_preset',store_preset,model.toJSON());
                if(store_preset){
                    _.extend(autocompleteOptions,{
                        displayFilters:true,
                        type:'store',
                        initialStore:app.getStore(store_preset)
                    });
                }
                var autocompleteView = view.attachView(new AddressAutocompleteView(autocompleteOptions)),
                    videoEl = view.$('video').get(0);
                view.autocompleteView = autocompleteView;
                view.listenToOnce(autocompleteView,'complete',view.onDeliveryUpdate);

                if(videoEl){
                    try {
                        window.makeVideoPlayableInline(videoEl);
                        videoEl.play();
                    }catch(err){
                        console.warn(err);
                    }
                }

                autocompleteView.on('focusIn', function () {
                    if (app.isDesktop()) {
                        $('html, body').animate({scrollTop: autocompleteView.$el.offset().top - $('.site-header').outerHeight() - 40}, 400);
                    }
                });

                InternalLinkView.initializeLinksOfView(view);
            },
            trackCTA:function(e){
                TagCommander.tc_ev_gl(e.currentTarget,'promotion_click',{model:view.model});
            },
            destroyVideo:function(){
                var view = this;
                //
                // essaie de supprimer l'instance CanvasVideo si elle existe
                //
                if(!_.isUndefined(view.video)){
                    console.log('destroyVideo');
                    try {
                        view.video.destroy();
                        delete view.video;
                        view.video = undefined;
                    }catch(err){
                        console.warn(err);
                    }
                }
            },
            remove:function(){
                var view = this;
                view.destroyVideo();
                delete view.autocompleteView; // supprime la référence pour être éligible au GC
                WidgetInstanceView.prototype.remove.apply(view);
            }
        })
    });

